import React, {useState, useMemo} from 'react';
import {View, Text, StyleSheet, TouchableOpacity} from 'react-native';

import {useCalendar} from '../DatePicker';
import {moderateScale} from "../../../../tools/Scaling";
import * as Colors from "../../../../tools/Colors";

const Days = () => {
    const DatePickerProps = useCalendar();
    //  console.log("DatePickerProps",DatePickerProps);
    const {options, state, utils, onDateChange} = DatePickerProps;
    const [mainState, setMainState] = state;
    const [itemSize, setItemSize] = useState(0);
    const style = styles(options);
    const days = useMemo(() => utils.getMonthDays(mainState.activeDate));

    const onSelectDay = date => {
        setMainState({
            type: 'set',
            selectedDate: date,

        });
        onDateChange(utils.getFormated(utils.getDate(date), 'dateFormat'));
    };

    const changeItemHeight = ({nativeEvent}) => {
        const {width} = nativeEvent.layout;
        !itemSize && setItemSize((width / 7).toFixed(2) * 1 - 0.5);
    };

    return (
        <View style={[style.container, utils.flexDirection,
            //{backgroundColor: "#eedd09"}
            ]} onLayout={changeItemHeight}>
            {days.map((day, n) => {
             //   console.log(day, n)
             //   let daySelect =day&&DatePickerProps.arraySelect.find(obj => obj.name === day.date)
                let daySelect =day&&DatePickerProps.arraySelect.find(obj => (day.date.search(obj.name ))>=0)

                return <View
                    key={n}
                    style={{
                        // width: itemSize,
                        // height: itemSize,
                        width: moderateScale(44),
                        height: moderateScale(30),
                        //backgroundColor: "#ee82d2",

                    }}>
                    {day && (
                        <TouchableOpacity
                            style={[
                                style.dayItem,
                                {
                                    borderRadius: moderateScale(10),
                                },
                                ( daySelect) && (daySelect.type?{}:style.dayItemSelected),
                                (mainState.selectedDate === day.date ) && {},
                            ]}
                            onPress={() => !day.disabled && onSelectDay(day.date)}
                            activeOpacity={0.8}>
                            <Text
                                style={[
                                 style.dayText,
                                    ( daySelect) && (    daySelect.type? {
                                        //fontFamily: moderateScale(12),
                                        color: Colors.red,
                                    }:style.dayTextSelected),
                                    (mainState.selectedDate === day.date ) && (daySelect&& daySelect.type?{}:{
                                    borderColor:Colors.blue,borderWidth:moderateScale(1),
                                        borderRadius:moderateScale(10),
                                        paddingVertical:moderateScale(4)
                                    }),
                                    day.disabled && style.dayTextDisabled,
                                ]}>
                                {day.dayString}
                            </Text>

                            <View style={{

                                position: 'absolute',
                                bottom: moderateScale(2),
                                //width: moderateScale(4),
                                // height: moderateScale(4),
                                //  backgroundColor: Colors.colorPrimary,
                                //borderRadius:moderateScale(2)
                            }}>
                                {/*<Icon name={daySelect ? "bulb" : ""}*/}
                                      {/*style={{fontSize: moderateScale(8), color: Colors.colorPrimary}}/>*/}
                            </View>
                        </TouchableOpacity>
                    )}
                </View>
            })}
        </View>
    );
};

const styles = theme =>
    StyleSheet.create({
        container: {
            width: '100%',
            height: '100%',
            flexWrap: 'wrap',
        },
        dayItem: {
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            margin: 3,
        },
        dayItemSelected: {
            backgroundColor: Colors.green,
        },
        dayText: {
            fontFamily: theme.defaultFont,
            fontSize: theme.textFontSize,
            color: theme.textDefaultColor,
            textAlign: 'center',
            width: '100%',
        },
        dayTextSelected: {
            color: theme.selectedTextColor,
            fontFamily: theme.headerFont,
        },
        dayTextDisabled: {
            opacity: 0.2,
        },
    });

export {Days};
